/**
 * Hooks shared by the Student & Parent portals. Kept out of portalShell.tsx so
 * that file only exports components (react-refresh friendly).
 */

import { useCallback, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { lessonTokenFor } from './roleProjections';

/** Open the real interactive lesson for a topic (falls back to the catalog). */
export function useOpenLesson() {
  const navigate = useNavigate();
  return useCallback((topicId: string) => {
    const token = lessonTokenFor(topicId);
    if (token) navigate({ to: '/learn/$shareToken', params: { shareToken: token } });
    else navigate({ to: '/learn' });
  }, [navigate]);
}

/** A localStorage-backed boolean, for demo toggles (WhatsApp digest, goals). */
export function useLocalFlag(key: string): [boolean, () => void] {
  const [on, setOn] = useState(() => {
    try { return localStorage.getItem(key) === '1'; } catch { return false; }
  });
  const toggle = useCallback(() => setOn((v) => {
    const nv = !v;
    try { localStorage.setItem(key, nv ? '1' : '0'); } catch { /* ignore */ }
    return nv;
  }), [key]);
  return [on, toggle];
}
